const ISTANBUL_TZ = 'Europe/Istanbul';

export const toJsDate = (value) => {
  if (!value) return null;
  if (typeof value?.toDate === 'function') {
    const d = value.toDate();
    return Number.isNaN(d.getTime()) ? null : d;
  }
  /*
   * Firestore zaman damgasi kayda yazilip geri okununca (sanitizeSnapshot,
   * JSON, Admin SDK) toDate()'i kaybeder ve {seconds, nanoseconds} ya da
   * {_seconds, _nanoseconds} duz nesnesine doner. new Date(nesne) NaN verir;
   * bu durumda tarih sessizce "yok" sayiliyordu.
   */
  const sn = typeof value === 'object' ? value.seconds ?? value._seconds : null;
  if (typeof sn === 'number') {
    const d = new Date(sn * 1000);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

const resolveBookingTimeFlags = (movement) => {
  if (movement?.bookingDateHasTime === true) {
    return {
      hasTime: true,
      hasSeconds: movement?.bookingDateHasSeconds === true
    };
  }
  if (movement?.bookingDateHasTime === false) {
    return { hasTime: false, hasSeconds: false };
  }

  const sourceTime = String(movement?.sourceTimeRaw || '').trim();
  if (sourceTime) {
    return {
      hasTime: true,
      hasSeconds: /:\d{2}:\d{2}/.test(sourceTime)
    };
  }

  const activity = String(movement?.activityDate || '');
  if (/T\d{2}:\d{2}/.test(activity) && !/T12:00:00/.test(activity)) {
    return {
      hasTime: true,
      hasSeconds: /T\d{2}:\d{2}:\d{2}/.test(activity)
    };
  }

  return { hasTime: false, hasSeconds: false };
};

export const formatBankingDatePart = (movement) => {
  const d = toJsDate(movement?.bookingDate || movement?.activityDate || movement?.valueDate);
  if (!d) return '-';
  return d.toLocaleDateString('tr-TR', { timeZone: ISTANBUL_TZ });
};

export const formatBankingTimePart = (movement) => {
  const flags = resolveBookingTimeFlags(movement);
  if (!flags.hasTime) return '-';

  const d = toJsDate(movement?.bookingDate || movement?.activityDate || movement?.valueDate);
  if (!d) return '-';

  const timeOpts = {
    timeZone: ISTANBUL_TZ,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  };
  if (flags.hasSeconds) {
    timeOpts.second = '2-digit';
  }
  return d.toLocaleTimeString('tr-TR', timeOpts);
};

/**
 * Banka hareketi tarih/saat gösterimi.
 */
export const formatBankingDateTime = (movement) => {
  const datePart = formatBankingDatePart(movement);
  if (datePart === '-') return '-';

  const flags = resolveBookingTimeFlags(movement);
  if (!flags.hasTime) return datePart;

  const timePart = formatBankingTimePart(movement);
  if (timePart === '-') return datePart;
  return `${datePart} ${timePart}`;
};

export const formatBankingValueDate = (movement) => {
  const d = toJsDate(movement?.valueDate || movement?.bookingDate);
  if (!d) return '-';
  if (movement?.valueDateHasTime === true) {
    const timeOpts = {
      timeZone: ISTANBUL_TZ,
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    };
    if (movement?.valueDateHasSeconds === true) timeOpts.second = '2-digit';
    return `${d.toLocaleDateString('tr-TR', { timeZone: ISTANBUL_TZ })} ${d.toLocaleTimeString('tr-TR', timeOpts)}`;
  }
  return d.toLocaleDateString('tr-TR', { timeZone: ISTANBUL_TZ });
};

/** İstanbul takvim günü (yyyy-mm-dd) — fatura tarih filtreleri için. */
export const getIstanbulDayKey = (value) => {
  const d = toJsDate(value);
  if (!d) return '';
  return d.toLocaleDateString('en-CA', { timeZone: ISTANBUL_TZ });
};

/** İstanbul saat dilimindeki saat/dakika (HH:mm) — fatura saati için. */
export const getIstanbulTimePart = (value) => {
  const d = toJsDate(value);
  if (!d) return '';
  return d.toLocaleTimeString('tr-TR', {
    timeZone: ISTANBUL_TZ,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
};

export const shiftIstanbulDayKey = (dayKey, deltaDays) => {
  if (!dayKey) return '';
  const [y, m, d] = dayKey.split('-').map(Number);
  const base = new Date(Date.UTC(y, m - 1, d));
  base.setUTCDate(base.getUTCDate() + deltaDays);
  return base.toISOString().slice(0, 10);
};
